// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"ae616ad8","211":"4967cf5a","262":"a3f56d66","443":"91baf651","497":"2a16ebd9","660":"ec36d290","677":"921283b2","890":"94cb9c2d"}[chunkId] + ".chunk.js";
};